module.exports = __webpack_public_path__ + "img/partner_logo08.1c848fc3.png";